<app-layout columnCount="12" maxWidth="24rem" vAlignment="middle">
  <app-layout-title>{{ 'AUTH.title' | translate }}</app-layout-title>

  <app-layout-content>
    <form (ngSubmit)="login()" [formGroup]="loginForm" class="grid">
      <mat-form-field>
        <mat-label>{{ 'AUTH.login' | translate }}</mat-label>
        <input #username="control"
          (cdkAutofill)="username.control.setValue($event.target.value)"
          [placeholder]="'AUTH.login' | translate"
          autocomplete="username"
          formControlName="username"
          matInput
          type="text">
        @if (username.hasError('required')) {
          <mat-error>
            {{ 'VALIDATION.required' | translate }}
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'AUTH.password' | translate }}</mat-label>
        <input #password="control"
          (cdkAutofill)="password.control.setValue($event.target.value)"
          [placeholder]="'AUTH.password' | translate"
          autocomplete="current-password"
          formControlName="password"
          matInput
          type="password">
        @if (password.hasError('required')) {
          <mat-error>
            {{ 'VALIDATION.required' | translate }}
          </mat-error>
        }
      </mat-form-field>

      <button [disabled]="loginForm.invalid" mat-flat-button color="primary" type="submit">
        {{ 'AUTH.sing_in' | translate }}
      </button>
      <button routerLink="/auth/forgot" mat-button type="button">
        {{ 'AUTH.forgot_question' | translate }}
      </button>
    </form>
  </app-layout-content>
</app-layout>
